<template>
<div>
    <v-progress-linear indeterminate color="primary" v-if="is_loading"></v-progress-linear>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
             <v-flex xs12>
                <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white"  text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white"  text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
            <v-flex xs11>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2 header">
                            <v-flex xs6 sm7>
                                <p class="text-color">Create Registration</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
                                <v-form id="create_registration"
                                 @submit.prevent="validateBeforeSubmit('createRegistration')"
                                  data-vv-scope="createRegistration" 
                                  ref="registration_form" 
                                  v-model="valid">
                                    <v-card-text>
                                        <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                <v-autocomplete 
                                                    :items="type_list" 
                                                    name="type" 
                                                    v-model="registration_object.type" 
                                                    label="Type" 
                                                    item-text="display_name" 
                                                    item-value="name" 
                                                    :disabled="invalid" 
                                                    clearable 
                                                    :error-messages="errors.collect('createRegistration.type')">
                                                 </v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5 v-if="registration_object.type=='visitor'">
                                                    <v-combobox v-model="registration_object.name" 
                                                    :items="visitoruser_list" 
                                                    name="Visitor Name"
                                                    label="Visitor Name"
                                                    item-text="name"
                                                    item-value="id"
                                                    :rules='required' 
                                                    v-validate="'required'"
                                                    v-on:change="visitoruser_changeFields()" 
                                                    :error-messages="errors.collect('createRegistration.Visitor Name')" 
                                                    :messages="visitoruser_search_message" 
                                                    :search-input.sync="registration_object.visitoruser_search">
                                                    <template v-slot:item="{ item }">

                                                            <v-list-item-content>
                                                                <v-list-item-title>{{item.name}} - {{item.mobile}}</v-list-item-title>
                                                            </v-list-item-content>

                                                        </template>
                                                          <template v-slot:label>
                                                            Visitor Name <span style="color:red"> * </span>
                                                        </template>
                                                    </v-combobox>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 v-if="registration_object.type=='vendor'">
                                                    <v-combobox v-model="registration_object.vendor" 
                                                    :items="vendor_list"
                                                    label="Vendor Name" 
                                                    item-text="name" 
                                                    item-value="id" 
                                                    name="Vendor Name" 
                                                    :rules='required' 
                                                    v-validate="'required'" 
                                                    v-on:change="vendor_changeFields()" 
                                                    :messages="vendor_search_message" 
                                                    :search-input.sync="registration_object.vendor_search"
                                                     :error-messages="errors.collect('createRegistration.Vendor Name')">
                                                        <template v-slot:item="{ item }">

                                                            <v-list-item-content>
                                                                <v-list-item-title>{{item.name}} - {{item.mobile}}</v-list-item-title>
                                                                <!-- <v-list-item-title> - </v-list-item-title> -->
                                                                <!-- <v-list-item-subtitle>{{item.mobile}}</v-list-item-subtitle> -->
                                                            </v-list-item-content>

                                                        </template>
                                                          <template v-slot:label>
                                                            Name <span style="color:red"> * </span>
                                                        </template>
                                                    </v-combobox>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-text-field name="Mobile" 
                                                    label="Mobile" 
                                                    id="mobile" 
                                                    :disabled="mobile_disable"
                                                    v-model="registration_object.mobile"
                                                    v-validate="'required|numeric|max:10|min:10'" 
                                                    :error-messages="errors.collect('createRegistration.Mobile')">
                                                        <template v-slot:label>
                                                            Mobile <span style="color:red"> * </span>
                                                        </template>
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                    <v-text-field name="Email" label="Email" id="email" :disabled="email_disable" v-model="registration_object.email" :error-messages="errors.collect('createRegistration.Email')"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-text-field name="Purpose" label="Purpose" id="id" v-model="registration_object.purpose" v-validate="'required'" :error-messages="errors.collect('createRegistration.Purpose')">
                                                        <template v-slot:label>
                                                            Purpose <span style="color:red"> * </span>
                                                        </template>
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>

                                                <v-flex xs12 sm6 md5 v-if="this.registration_object.type=='vendor'|| 'visitor'">
                                                    <v-menu v-model="from_menu" :close-on-content-click="false" transition="scale-transition" :nudge-right="40" offset-y max-width="290px" min-width="290px">

                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field 
                                                            v-on="on"
                                                             name="From Date"
                                                              v-model="registration_object.from_date" 
                                                              label="Visit Date" 
                                                              v-validate="'required'" 
                                                              :error-messages="errors.collect('createRegistration.From Date')"
                                                               readonly>
                                    
                                                                <template v-slot:label>
                                                                    From Date <span style="color:red"> * </span>
                                                                </template>
                                                                 
                                                            </v-text-field>
                                                        </template>

                                                        <v-date-picker 
                                                        v-if="from_menu" :min="nowDate" v-model="registration_object.from_date" @input="from_menu = false">

                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1 v-show="role=='Super Admin'" v-if="registration_object.type=='visitor'">
                                                    <v-autocomplete 
                                                    :items="office_list" 
                                                    name="Office" 
                                                    v-model="registration_object.office_id" 
                                                    :search-input.sync="registration_object.office_search" label="Office" item-text="name" item-value="id" :messages="office_search_message" clearable ><template v-slot:label v-if="registration_object.type=='visitor'">
                                                                Office<span style="color:red"> * </span>
                                                            </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1 v-if="this.registration_object.type=='vendor'">
                                                    <v-menu ref="to_menu" v-model="to_menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field label="To Date"
                                                             readonly v-on="on"
                                                              name="To Date"
                                                               v-model="registration_object.to_date" 
                                                               v-validate="'required|'" 
                                                               :error-messages="errors.collect('createRegistration.To Date')">
                                                                <template v-slot:label v-if="registration_object.type=='vendor'">
                                                                    To Date<span style="color:red"> * </span>
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker v-if="to_menu" :min="registration_object.from_date" v-model="registration_object.to_date" @input="to_menu = false">

                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>
                                            <!-- ------------------------------- -->
                                            <v-layout row wrap v-if="this.registration_object.type=='visitor'">
                                                <v-flex xs12 sm6 md5>
                                                    <v-menu v-model="from_time_menu" :close-on-content-click="false" transition="scale-transition" :nudge-right="40" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field label="From Time" readonly v-on="on" name="From Time" v-model="registration_object.start_time" v-validate="'required'" :error-messages="errors.collect('createRegistration.From Time')">
                                                                <template v-slot:label>
                                                                    From Time <span style="color:red"> * </span>
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-time-picker v-if="from_time_menu" v-model="registration_object.start_time" @input="from_time_menu = false" ampm-in-title>
                                                        </v-time-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-menu v-model="to_time_menu" :close-on-content-click="false" transition="scale-transition" :nudge-right="40" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field label="To Time" readonly v-on="on" name="End Time" v-model="registration_object.end_time" v-validate="'required'" :error-messages="errors.collect('createRegistration.End Time')">
                                                                <template v-slot:label>
                                                                    To Time <span style="color:red"> * </span>
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-time-picker v-if="to_time_menu" :min="registration_object.start_time" v-model="registration_object.end_time" @input="to_time_menu = false" ampm-in-title>
                                                        </v-time-picker>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>
                                            <!-- <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                <label> <span style="color:grey; font-size:16px;">From Time</span> </label>
                                                    <div class="input-wrapper" style="border-bottom:1px solid; border-color: rgb(204, 204, 204); height: 50%; padding:13px;">
                                                        <flat-pickr v-model="registration_object.start_time" name="date_range" :config="date_config"></flat-pickr>
                                                    </div>
                                                </v-flex> 
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                <label> <span style="color:grey; font-size:16px;"> To Time </span> </label>
                                                    <div class="input-wrapper" style="border-bottom:1px solid; border-color: rgb(204, 204, 204); height: 50%; padding:13px;">
                                                        <flat-pickr v-model="registration_object.to_time" name="date_range" :config="date_config"></flat-pickr>
                                                    </div>
                                                </v-flex>
                                            </v-layout> -->

                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" small :disabled="!valid" :loading="loading" type="submit">Register</v-btn>
                                        <v-btn text small to="/registrations">Cancel</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
    watch: {
        "registration_object.office_search": {
            handler(val) {
                if (val) {
                    if (val.length >= 3) {
                        this.office_search_message = "";
                        this.getOfficeList();
                    }
                } else {
                    this.office_search_message = "Enter atleast 3 characters";
                }

            }
        },
        "registration_object.start_time": {
            handler(val) {
                if (val) {
                    this.registration_object.end_time = moment(val,'HH:mm').add(1, 'hour').format('HH:mm');
                } 

            }
        },
        "registration_object.from_date": {
            handler(val) {
                if (val) {
                    this.registration_object.to_date = moment(val,'YYYY-MM-DD').add(0, 'day').format('YYYY-MM-DD')
                } 

            }
        },

        "registration_object.vendor_search": {
            handler(val) {
                if (val) {
                    if (val.length >= 3) {
                        this.vendor_search_message = "";
                        this.getVendorList();
                    }
                } else {
                    this.vendor_search_message = "Enter atleast 3 characters";
                    this.registration_object.mobile ='';
                    this.mobile_disable = false;
                    this.registration_object.email ='';
                    this.email_disable = false;

                }

            }
        },
        "registration_object.visitoruser_search": {
            handler(val) {
                if (val) {
                    if (val.length >= 3) {
                        this.visitoruser_search_message = "";
                        this.getUserList();
                    }
                } else {
                    this.visitoruser_search_message = "Enter atleast 3 characters";
                    this.registration_object.mobile = '';
                    this.mobile_disable = false;
                    this.registration_object.email ='';
                    this.email_disable = false;
                }

            }
        },

        "registration_object.purpose": {
            deep: true,
            handler(val) {
                if (val) {
                    this.registration_object.purpose = val.charAt(0).toUpperCase() + val.slice(1);
                }

            }
        },

    },
    methods: {
        visitor_todate: function (scope) {

            this.registration_object.to_date = this.registration_object.from_date;

        },
        visitoruser_changeFields: function (scope) {

            var selected = this.registration_object.name;
            if (selected.name != null) {
                this.registration_object.name = selected.name;

            }
            if (selected.mobile != null) {
                this.registration_object.mobile = selected.mobile;
                this.mobile_disable = true;
            }
            if (selected.email != null) {
                this.registration_object.email = selected.email;
                this.email_disable = true;
            }

        },
        vendor_changeFields: function (scope) {

            var selected = this.registration_object.vendor;
            if (selected.name != null) {
                this.registration_object.name = selected.name;

            }
            if (selected.mobile != null) {
                this.registration_object.mobile = selected.mobile;
                this.mobile_disable = true;
            }
            if (selected.email != null) {
                this.registration_object.email = selected.email;
                this.email_disable = true;
            }
        },
        validateBeforeSubmit: function (scope) {
            if (this.registration_object.type == 'visitor') {
                this.registration_object.to_date = this.registration_object.from_date;
            }
            this.$validator.validateAll(scope).then(result => {
                if (result) { this[scope](); }
            });
        },
        getRegistrationDetailsvisitorDublicate: function () {

            axios.get(`${process.env.VUE_APP_API_URL}/api/visitors/` + this.$route.params.id).then(response => {
                    if (response.data.status == 1) {
                        var visitor_details = response.data.visitor_details;
                        this.registration_object.type = 'visitor';
                        this.registration_object.name = visitor_details.name;
                        this.registration_object.mobile = visitor_details.mobile;
                        this.registration_object.email = visitor_details.email

                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {

                });

        },
        getRegistrationDetailsDublicate: function () {

            axios.get(`${process.env.VUE_APP_API_URL}/api/registrations/` + this.$route.params.id + `/edit`)
                .then(response => {

                    if (response.data.status == 1) {
                        var dublicate_obj = response.data.registration;
                        this.registration_object.type = dublicate_obj.type;
                        this.registration_object.name = dublicate_obj.record.name;
                        this.registration_object.vendor = dublicate_obj.record.name;
                        this.registration_object.mobile = dublicate_obj.record.mobile;
                        this.registration_object.email = dublicate_obj.record.email
                        this.registration_object.purpose = dublicate_obj.purpose;

                        this.registration_object.start_time = moment(dublicate_obj.from_date).format('H:mm');
                        this.registration_object.end_time = moment(dublicate_obj.to_date).format('H:mm');

                        this.registration_object.from_date = moment(dublicate_obj.from_date).format('YYYY-MM-DD');
                        this.registration_object.to_date = moment(dublicate_obj.to_date).format('YYYY-MM-DD');

                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },
        getRegistrationDetailsvendorDublicate: function () {

            axios.get(`${process.env.VUE_APP_API_URL}/api/Vendors/` + this.$route.params.id).then(response => {
                 
                    if (response.data.status == 1) {
                        var vendor_details = response.data.vendor_details;
                        this.registration_object.type = 'vendor';
                        this.registration_object.vendor = vendor_details.name;
                        this.registration_object.mobile = vendor_details.mobile;
                        this.registration_object.email = vendor_details.email

                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {

                });
        },
        createRegistration: function () {
            this.loading = true;
            if (this.registration_object.type == 'visitor') {
                this.registration_object.to_date = this.registration_object.from_date;
            }

            if (this.registration_object.vendor === this.registration_object.vendor_search) {
                this.registration_object.vendor = {};
                this.registration_object.vendor.id = null;
                this.registration_object.vendor.name = this.registration_object.vendor_search;
                this.registration_object.vendor.email = this.registration_object.email;
                this.registration_object.vendor.mobile = this.registration_object.mobile;

            }

            let new_registration = Object.assign({}, this.registration_object);
            axios.post(`${process.env.VUE_APP_API_URL}/api/registrations`, new_registration).then((response) => {
                if (response.data.status == 1) {
                    this.$router.push({
                        name: 'showRegistrationDetails',
                        params: {
                            id: response.data.registration.id
                        }
                    });
                    this.loading = true;
                }
               
                if (response.data.status == 0) {
                    this.alert_error=true;
                    this.error = response.data.message;
                    this.loading = false;
                }
            }).catch((error) => {
                console.log(error);
            }).finally(() => {

            });
        },
        getOfficeList: function () {
            axios.get(`${process.env.VUE_APP_API_URL}/api/offices/list`, {
                params: {
                    query_string: this.registration_object.office_search
                }
            }).then((response) => {
                if (response.data.status == 1) {
                    this.office_list = response.data.office_list;
                }
                if (response.data.status == 0) {
                    this.error = "Error Occured";
                    this.is_loading = false;
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
        getVendorList: function () {
            axios.get(`${process.env.VUE_APP_API_URL}/api/vendors/list`, {
                params: {
                    query_string: this.registration_object.vendor_search
                }
            }).then((response) => {
                if (response.data.status == 1) {
                    this.vendor_list = response.data.vendor_list;
                }
                if (response.data.status == 0) {
                    this.error = "Error Occured";
                    this.is_loading = false;
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
        getUserList: function () {
            axios.get(`${process.env.VUE_APP_API_URL}/api/visitors/list`, {
                params: {
                    query_string: this.registration_object.visitoruser_search
                }
            }).then((response) => {
                if (response.data.status == 1) {
                    this.visitoruser_list = response.data.visitor_list;

                }
                if (response.data.status == 0) {
                    this.error = "Error Occured";
                    this.is_loading = false;
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
    },
    data: () => {
        return {
            role: '',
            is_loading: false,
            error: '',
            title: '',
            vendor_details: '',
            email_disable: false,
            mobile_disable: false,
            registration_object: {
                name: '',
                mobile: '',
                purpose:'',
                email: '',
                type: '',
                from_date: '',
                to_date: '',
                start_time: '',
                end_time: '',
            },
            date_config: {
                // wrap: false, // set wrap to true only when using 'input-group'
                // altFormat: 'j M, Y',
                // altInput: true,
                // dateFormat: 'Y-m-d',
                // mode: 'range',

                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: false
            },
            nowDate: new Date().toISOString().slice(0, 10),
            required: [v => !!v || "The input is required"],
            office_list: [],
            vendor_list: [],
            type_list: [],
            visitoruser_list: [],
            valid: false,

            from_date_menu: false,
            to_date_menu: false,
            from_menu: false,
            to_menu: false,

            from_time_menu: false,
            to_time_menu: false,
            from_time_menu: false,
            to_time_menu: false,
            loading: false,

            message:'',
            alert:'',
            alert_error:'',

            invalid: true,
            office_search_message: "Enter atleast 3 characters",
            vendor_search_message: "Enter atleast 3 characters",
            visitoruser_search_message: "Enter atleast 3 characters",
        }
    },

    mounted() {

        this.role = localStorage.getItem('visitor_management_role');
        if (this.$route.params.dublicate == true) {
           
            this.getRegistrationDetailsDublicate();
        }
        if (this.$route.params.visitordublicate == true) {
           
            this.getRegistrationDetailsvisitorDublicate();
        }
        if (this.$route.params.vendordublicate == true) {
           
            this.getRegistrationDetailsvendorDublicate();
        }

        if (this.role == "Super Admin") {
            
            this.invalid = false;
            this.registration_object.type = 'vendor';
            this.type_list = [{
                'name': 'visitor',
                'display_name': 'Visitor',
            }, {
                'name': 'vendor',
                'display_name': 'Vendor',
            }]
        } else if (this.role == "Society Admin") {
          
            this.registration_object.type = 'vendor';
            this.title = "Vendor";
            this.type_list = [{
                'name': 'vendor',
                'display_name': 'Vendor',
            }];
            
        } else if (this.role == "Office Admin") {
            this.registration_object.type = 'visitor';
            this.title = "Visitor";
            this.type_list = [{
                'name': 'visitor',
                'display_name': 'Visitor',
            }];
            
        }
    }
};
</script>
